export const environment = {
	production: false,
	ENV: 'development-azure',
	API_URL: 'https://api.dev.schoolbookkeeping.linq.com',
	BUILD_DATE: process.env.BUILD_DATE,
	BUILD_ID: process.env.BUILD_ID,
	DD_APP_ID: '4af43206-4807-41b3-a580-5324f67fb98c',
	DD_TOKEN: 'pub8e31a87b2f11f45515b45326f6e9b8b9',
	DD_SERVICE: 'safm-webapp',
	DD_SITE: 'us3.datadoghq.com',
	FEE_MANAGEMENT_URL: 'https://dev.portal.schoolnutrition.linq.com',
	OIDC_AUTHORITY: 'https://dev.accounts.linq.com',
	OIDC_CLIENT_ID: 'hcDiOGqitMfi6JP27rDaqm8ljXEI3Z4R',
	OIDC_AUDIENCE: 'https://api.dev.schoolbookkeeping.linq.com/api',
};
